<template>
  <v-card tile flat>
    <v-card-title>
      <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        label="Sök..."
        rounded
        single-line
        dense
        filled
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <slot name="toolbar-right" />
    </v-card-title>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="tableData"
      :search="search"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      v-model="selected"
      hide-default-footer
      disable-pagination
      item-key="uuid"
      :show-select="type !== 'crew'"
      fixed-header
      @item-selected="onItemSelect"
      @toggle-select-all="onToggleAllSelect"
      :height="tableHeight"
    >
      <template v-slot:item.actions="{ item }">
        <template v-for="(actionItem, $i) in actions">
          <v-dialog
            :key="$i"
            v-model="item[`_show-${actionItem.type}-modal`]"
            width="600"
            persistent
          >
            <component
              v-if="item[`_show-${actionItem.type}-modal`]"
              :item="item"
              :is="actionItem.component"
              @close-modal="item[`_show-${actionItem.type}-modal`] = false"
              @close="item[`_show-${actionItem.type}-modal`] = false"
            />
          </v-dialog>
        </template>
        <v-menu left>
          <template #activator="{ attrs, on }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <template v-for="(actionItem, $i) in actions">
              <v-list-item
                :key="$i"
                @click="item[`_show-${actionItem.type}-modal`] = true"
              >
                <v-list-item-icon>
                  <v-icon small v-text="actionItem.icon"></v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ actionItem.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import inputTableHeight from '@/mixins/inputTableHeight'
import gql from 'graphql-tag'
import uppercaseFirst from '@/common/uppercaseFirst'

export default {
  name: 'InputTableContainer',

  mixins: [inputTableHeight(465 - 48)],

  props: {
    headers: Array,
    data: Array,
    actions: Array,
    loading: Boolean,
    type: String,
    sortBy: [String, Array],
    sortDesc: {
      type: Boolean,
      default: () => true
    }
  },

  data: () => ({
    search: '',
    selected: []
  }),

  watch: {
    tableData: {
      handler(data) {
        this.selected = data.filter(x => x.checked)
      },
      immediate: true
    }
  },

  computed: {
    tableData() {
      return this.data
        .filter(x => !x.deleted)
        .map(x => ({
          ...x,
          ...this.actions.reduce((acc, action) => {
            acc[`_show-${action.type}-modal`] = false
            return acc
          }, {})
        }))
    }
  },

  methods: {
    async onItemSelect({ item, value }) {
      const type = this.type === 'rejectedStop' ? 'trainDeviation' : this.type
      this.$store.set(`${type}/data@${item.uuid}.checked`, value)

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: SetCheckedInput!) {
            setChecked${uppercaseFirst(type)}(payload: $payload) {
              uuid
            }
          }
        `,
        variables: {
          payload: {
            uuid: item.uuid,
            checked: value
          }
        }
      })
    },

    onToggleAllSelect({ items, value }) {
      for (let item of items) {
        this.onItemSelect({ item, value })
      }
    }
  }
}
</script>
